module.exports = __webpack_public_path__ + "static/img/1063.4339305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1063.jpg
// module id = 245
// module chunks = 0